<!--
    Summary:
        首页
    ChangeLog:
        zty on 2021/11/18 added
-->
<template>
  <div class="v-home">
     <div class="v-swipe">
       <div class="swipe_content">
         <div class="swipe_title_1">{{$t('indexText.home_title')}}</div>
         <div class="swipe_title_2">{{$t('indexText.home_title_1')}}</div>
         <div class="swipe_btn_group">
           <div class="group_item">{{$t('indexText.web_build')}}</div>
           <div class="group_item">{{$t('indexText.phone_build')}}</div>
           <div class="group_item">{{$t('indexText.min_build')}}</div>
           <div class="group_item">{{$t('indexText.share_build')}}</div>
         </div>
       </div>
     </div>

     <div class="content_infos">
       <div class="content_item_i">
         <div class="item_i_left">
           <div class="left_title">{{$t('indexText.content_title_1')}}</div>
           <div class="left_title_descript" :class="$store.state.lang=='en-US'?'left_contents_spencel':''">{{$t('indexText.content_title_content_1')}}</div>
           <div class="left_contents" :class="$store.state.lang=='en-US'?'left_contents_spencel':''">
              <div>{{$t('indexText.content_title_description_1')}}</div>
              <div>{{$t('indexText.content_title_description_1_1')}}</div>
              <div>{{$t('indexText.content_title_description_1_2')}}</div>
            </div>
            <div class="left_btn_group">
              <div class="register" @click="register">{{$t('product.register')}}</div>
              <div class="learn_more" @click="learMore">{{$t('indexText.more')}}</div>
            </div>
         </div>
         <div class="item_i_right">
           <img src="../assets/images/home/home_content_1.png" />
         </div>
       </div>

       <div class="content_item_i">
         <div class="item_i_right_text">
            <img src="../assets/images/home/home_content_2.png" />
         </div>
         <div class="item_i_left_img">
           <div class="left_title">{{$t('indexText.content_title_2')}}</div>
           <div class="left_title_descript" :class="$store.state.lang=='en-US'?'left_contents_spencel':''">{{$t('indexText.content_title_content_2')}}</div>
           <div class="left_contents" :class="$store.state.lang=='en-US'?'left_contents_spencel':''">
              <div>{{$t('indexText.content_title_description_2')}}</div>
              <div>{{$t('indexText.content_title_description_2_1')}}</div>
            </div>
            <div class="left_btn_group">
              <div class="register" @click="register">{{$t('product.register')}}</div>
              <div class="learn_more" @click="learMore">{{$t('indexText.more')}}</div>
            </div>
         </div>
       </div>

       <div class="content_item_i">
         <div class="item_i_left">
           <div class="left_title">{{$t('indexText.content_title_3')}}</div>
           <div class="left_title_descript">{{$t('indexText.content_title_content_3')}}</div>
           <div class="left_contents" :class="$store.state.lang=='en-US'?'left_contents_spencel':''">
              <div>{{$t('indexText.content_title_description_3')}}</div>
              <div>{{$t('indexText.content_title_description_3_1')}}</div>
              <div>{{$t('indexText.content_title_description_3_2')}}</div>
            </div>
            <div class="left_btn_group">
              <div class="register" @click="register">{{$t('product.register')}}</div>
              <div class="learn_more" @click="learMore">{{$t('indexText.more')}}</div>
            </div>
         </div>
         <div class="item_i_right">
           <img src="../assets/images/home/home_content_3.png" />
         </div>
       </div>
       
       <div class="content_item_i">
         <div class="item_i_right_text">
           <img src="../assets/images/home/home_content_4.png" />
         </div>
         <div class="item_i_left_img">
           <div class="left_title">{{$t('indexText.content_title_4')}}</div>
           <div class="left_title_descript" :class="$store.state.lang=='en-US'?'left_contents_spencel':''">{{$t('indexText.content_title_content_4')}}</div>
           <div class="left_contents" :class="$store.state.lang=='en-US'?'left_contents_spencel':''">
              <div>{{$t('indexText.content_title_description_4')}}</div>
              <div>{{$t('indexText.content_title_description_4_1')}}</div>
              <div> {{$t('indexText.content_title_description_4_2')}}</div>
            </div>
            <div class="left_btn_group">
              <div class="register" @click="register">{{$t('product.register')}}</div>
              <div class="learn_more" @click="learMore">{{$t('indexText.more')}}</div>
            </div>
         </div>
       </div>
     </div>

     <div class="content_bottom_i">
       <div class="content_bottom_info">
         <div class="bottom_title">{{$t('indexText.give_function')}}</div>
         <div class="img_group">
           <div class="imge_item">
             <img src="../assets/images/home/bg_item_1.png" />
           </div>
           <div class="imge_item">
             <img src="../assets/images/home/bg_item_2.png" />
           </div>
           <div class="imge_item">
             <img src="../assets/images/home/bg_item_3.png" />
           </div>
         </div>
         <div class="img_group">
           <div class="imge_item">
             <img src="../assets/images/home/bg_item_4.png" />
           </div>
           <div class="imge_item">
             <img src="../assets/images/home/bg_item_5.png" />
           </div>
           <div class="imge_item">
             <img src="../assets/images/home/bg_item_6.png" />
           </div>
         </div>
         <div class="consulting_service" @click="register">
           <span>{{$t('indexText.consulting_service')}}</span>
          </div>
       </div>
     </div>
  </div>
</template>

<script>

export default {
  name: 'home',
  computed: {
    isEn: function () {
      return this.$store.state.lang == 'en-US'
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou youkeyi Network Technology Co., Ltd',
        'zh-TCC': '廣州市優科易網絡科技有限公司',
        'zh-CN': '广州市优科易网络科技有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  components: {

  },
  data () {
    return {
      pageTitle: '广州市优科易网络科技有限公司',
      
    }
  },
  mounted () {

  },
  beforeDestroy () {
    window.onscroll = null;
  },
  methods: {
     register(){
       this.$router.push({
        path: '/about'
      })
     },
     learMore(){
       
       this.$router.push({
        path: '/cases'
      })
     }
  },
}
</script>


<style scoped lang="scss">
.v-home {
  .v-swipe{
    background:#000000;
    background: url('~@/assets/images/home/home_bg.png') no-repeat;
    background-size: 100% 100%;
    color:#ffffff;
    .swipe_content{
      padding-top:134px;
      text-align: center;
      .swipe_title_1{
          font-size: 68px;
          font-weight: bold;
          letter-spacing: 7px;
          color: #ffffff;
          cursor: pointer;
      }
      .swipe_title_2{
        
          font-size: 68px;
          font-weight: bold;
          letter-spacing: 7px;
          color: #ffffff;
          cursor: pointer;
      }
      .swipe_btn_group{
       width:65%;
       margin:auto;
       padding-top:87px;
       padding-bottom: 158px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        .group_item{
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items:  center;
          margin-right:56px;
          margin-top:12px;
          width: 180px;
          height: 56px;
          background-color: #333333;
          border-radius: 28px;
          border: solid 1px #ffffff;
          // background-color:transparent;
          opacity:0.6;
        }
      }
    }
  }

  .content_infos{
    padding-top:101px;
    padding-bottom:173px;     
    width:72%;
    margin:auto;
      .content_item_i{
        display:flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom:59px;
        .item_i_left{
          display:flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          padding-bottom:40px;
          // width:292px;
          .left_title{
            font-size: 26px;
            font-weight: bold;
            color: #333333;
          }
          .left_title_descript{
            margin-top:25px;
            font-size: 16px;
            color: #999999;
          }
          .left_contents{
            margin-top:40px;
            font-size: 18px;
            color: #333333;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            line-height: 30px;
          }
          .left_contents_spencel{
            
            max-width: 500px !important;
            text-align: left !important;
          }
          .left_btn_group{
            margin-top:51px;
            display:flex;
            align-items: center;
            justify-content: flex-start;
             .register{
               width: 128px;
                height: 44px;
                background-color: #0572cc;
                border-radius: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                color:#ffffff;
                cursor: pointer;
             }
             .learn_more{
                margin-left:8px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 128px;
                height: 44px;
                background-color: #ffffff;
                border-radius: 8px;
                border: solid 1px #0572cc;                
                color:#0572cc;
                cursor: pointer;

             }
          }
        }
        .item_i_right{
          max-width: 650px;
          // height: 412px;
          background-color: #eeeeee;
          border-radius: 10px;
          img{
            width: 100%;
            height: auto;
          }
        }

        .item_i_left_img{
          display:flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          padding-bottom:40px;
          padding-top:40px;
          
          // width:292px;
          .left_title{
            font-size: 26px;
            font-weight: bold;
            color: #333333;
          }
          .left_title_descript{
            margin-top:25px;
            font-size: 16px;
            color: #999999;
          }
          .left_contents{
            
            margin-top:40px;
            font-size: 18px;
            color: #333333;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            line-height: 30px;
            max-width: 500px;
            text-align: left;
          }
          
          .left_contents_spencel{
            
            max-width: 500px !important;
            text-align: left !important;
          }
          .left_btn_group{
            margin-top:51px;
            display:flex;
            align-items: center;
            justify-content: flex-start;
             .register{
               width: 128px;
                height: 44px;
                background-color: #0572cc;
                border-radius: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                color:#ffffff;
                cursor: pointer;
             }
             .learn_more{
                margin-left:8px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 128px;
                height: 44px;
                background-color: #ffffff;
                border-radius: 8px;
                border: solid 1px #0572cc;                
                color:#0572cc;
                cursor: pointer;

             }
          }
        }
        .item_i_right_text{
          width: 650px;
          // height: 412px;
          background-color: #eeeeee;
          border-radius: 10px;
           img{
            width: 100%;
            height: auto;
          }
        }

      }
  }

  .content_bottom_i{
    background-color: #333333;
    
    background: url('~@/assets/images/home/bg_bottom.png') no-repeat;
    background-size: 100% 100%;
    .content_bottom_info{
      width:60%;
      margin:auto;
      text-align: center;
      display: flex;
      align-items: center;
      justify-items: center;
      flex-direction: column;
      .bottom_title{
        padding-top:101px;
        font-size: 32px;
        font-weight: bold;
        letter-spacing: 0px;
        color: #ffffff;
        margin-bottom: 70px;
      }
      .img_group{
        
        display: flex;
        justify-content: center;
        align-items: center;
        // flex-wrap: wrap;
        .imge_item{
          // height: 160px;
          margin-right:10px;
          margin-bottom:10px;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      .consulting_service{
        margin-top:67px;
        // width: 240px;
        // height: 48px;
        padding:18px 20px;
        background-color: #0572cc;
        border-radius: 6px;
        color:#ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom:100px;
        font-size: 21px;
      }
    }
  }
}
</style>




<style>

/* 超小屏幕（手机，小于 768px） */
/* 没有任何媒体查询相关的代码，因为这在 Bootstrap 中是默认的（还记得 Bootstrap 是移动设备优先的吗？） */

/* 小屏幕（平板，大于等于 768px） */
@media (min-width: @screen-sm-min) { 
   
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: @screen-md-min) { 

 }

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) { 

}
@media (max-width: 750px){
  
 
}
@media (min-width: 750px) and (max-width: 860px){

}
@media (min-width: 860px) and (max-width:1200px){
  
 
}
@media (min-width: 1480px){                  
    .content_infos{
      width:55% !important;
      margin:auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue